import { render } from "./CampaignResults.vue?vue&type=template&id=8b7a32e8"
import script from "./CampaignResults.vue?vue&type=script&lang=js"
export * from "./CampaignResults.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__